export { AppInsights } from './AppInsights';
